import { ImageSize } from '@/interfaces/imageSize';

export const UNAUTHORIZED_MESSAGES = [
  "Access denied! You don't have permission for this action!",
  'Access denied! You need to be authorized to perform this action!',
  'Brak uprawnień.'
];

export const EVENT_COLOR = '#3788d8';

export const EVENT_FEE_COLOR = 'brown';

export const EDIT_ACTION = {
  event: 'edit',
  icon: 'fal fa-fw fa-pencil',
  class: 'btn-edit',
  toolTipText: 'buttons.edit',
  permissionsTypes: ['UPDATE']
};

export const DELETE_ACTION = {
  event: 'delete',
  icon: 'fal fa-fw fa-trash',
  class: 'btn-delete',
  toolTipText: 'buttons.delete',
  permissionsTypes: ['DELETE']
};

export const ADD_ACTION = {
  event: 'add',
  icon: 'fal fa-fw fa-plus',
  class: 'btn-add',
  toolTipText: 'buttons.add',
  permissionsTypes: ['ADD']
};

export const ROLES_ACTION = {
  event: 'roles',
  icon: 'fal fa-sitemap',
  class: 'btn-roles',
  toolTipText: 'buttons.roles',
  permissionsTypes: ['ROLE_MANAGE']
};

export const VIEW_ACTION = {
  event: 'view',
  icon: 'fal fa-fw fa-address-card',
  class: 'btn-view',
  toolTipText: 'buttons.view',
  permissionsTypes: ['GET']
};

export const UP_ACTION = {
  event: 'up',
  icon: 'fal fa-arrow-alt-up ',
  permissionsTypes: ['UPDATE'],
  toolTipText: 'buttons.up'
};

export const DOWN_ACTION = {
  event: 'down',
  icon: 'fal fa-arrow-alt-down',
  permissionsTypes: ['UPDATE'],
  toolTipText: 'buttons.down'
};

export const ACCEPT_ACTION = {
  event: 'accept',
  icon: 'fal fa-envelope',
  class: 'btn-view',
  toolTipText: 'buttons.see',
  permissionsTypes: ['ACCEPT']
};

export const PRESENCE_ACTION = {
  event: 'presence',
  icon: 'fal fa-fw fa-calendar-check',
  class: 'btn-edit',
  toolTipText: 'buttons.check-presence',
  permissionsTypes: ['UPDATE', 'ADD']
};

export const MEDICAL_EXAMINATION_ACTION = {
  event: 'viewMedicalExaminations',
  icon: 'fal fa-file-medical ',
  class: 'btn-medical-examination',
  toolTipText: 'buttons.medicalExamination',
  permissionsTypes: ['LIST']
};

export const EXAM_RESULT_ACTION = {
  event: 'viewExamResults',
  icon: 'fal fa-chart-line',
  class: 'btn-exam-result',
  toolTipText: 'buttons.examResult',
  permissionsTypes: ['LIST']
};

export const CREATE_ACCOUNT_ACTION = {
  event: 'createAccount',
  icon: 'fal fa-user-plus',
  class: 'btn-create-account',
  toolTipText: 'buttons.createAccount',
  permissionsTypes: ['LIST'],
  disabledIfField: 'email'
};

export const GRANT_MANAGER_PERMISSIONS_ACTION = {
  event: 'grantManagerPermissions',
  icon: 'fal fa-sitemap',
  class: 'btn-grant-permissions',
  toolTipText: 'buttons.grantManagerPermissions',
  permissionsTypes: ['GRANT_MANAGER_PERMISSIONS']
};

export const DEFAULT_TABLE_ACTIONS = [EDIT_ACTION, DELETE_ACTION];

export const MEDIA_URL = process.env.VUE_APP_MEDIA_URL;

export const TILES_URL = process.env.VUE_APP_TILES_URL;

export const DEFAULT_COUNT = 10;

export const AVATAR_SIZE: ImageSize = { width: 250, height: 250 };

export const GRAVATAR_URL = 'https://www.gravatar.com/avatar/';
